// W28 — 试用冻结墙: 时间到或 credit 耗尽任一先到即全屏冻结。
// 毛玻璃背景 + 仅家庭版/商用版激活卡 + 数据保留承诺 (纯激活, 无只读浏览入口)。
import PlanSelector from './PlanSelector';
import { useT } from '../i18n';
import { Snowflake, ShieldCheck } from 'lucide-react';

export default function FreezeWall({ lockedReason, walletData }) {
  const t = useT();
  const creditExhausted = lockedReason === 'trial_credit_exhausted';

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center overflow-y-auto p-4"
      style={{ backgroundColor: 'rgba(0,0,0,0.55)', backdropFilter: 'blur(14px)', WebkitBackdropFilter: 'blur(14px)' }}>
      <div className="w-full max-w-3xl rounded-2xl border p-6 md:p-8 flex flex-col gap-5"
        style={{ backgroundColor: 'var(--bg-card)', borderColor: 'var(--border)', boxShadow: 'var(--shadow-card)' }}>
        <div className="flex items-start gap-3">
          <span className="w-10 h-10 rounded-xl inline-flex items-center justify-center shrink-0"
            style={{ background: 'rgba(59,130,246,0.12)', color: 'var(--text-brand)' }}>
            <Snowflake size={20} />
          </span>
          <div className="flex-1">
            <h1 className="text-lg font-bold" style={{ color: 'var(--text-primary)' }}>
              {creditExhausted ? t('plan_sel.frozen_credit_title') : t('plan_sel.frozen_title')}
            </h1>
            <p className="text-sm mt-0.5" style={{ color: 'var(--text-muted)' }}>
              {creditExhausted ? t('plan_sel.frozen_credit_sub') : t('plan_sel.frozen_sub')}
            </p>
          </div>
        </div>
        <PlanSelector walletData={walletData} />
        <p className="text-xs inline-flex items-center gap-1.5 rounded-lg px-3 py-2"
          style={{ backgroundColor: 'rgba(46,204,113,0.08)', border: '1px solid rgba(46,204,113,0.25)', color: 'var(--text-secondary)' }}>
          <ShieldCheck size={13} style={{ color: 'var(--text-brand)' }} />
          {t('plan_sel.frozen_data_note')}
        </p>
      </div>
    </div>
  );
}
